import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.memoryStepThreeCollections.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.memoryStepThreeCollections.data.currency,
  (currency = {}) => currency
);
const getCollectionsData = createSelector(
  (state) => state.memoryStepThreeCollections.data.memoryStepThreeCollections,
  (collections = []) => collections
);
const getGroupLabel = createSelector(
  (state) => state.memoryStepThreeCollections.data.memoryStepThreeGroupLabel,
  (groupLabel = '') => groupLabel
);
const getPageCount = createSelector(
  (state) => state.memoryStepThreeCollections.data.pageCount,
  (pageCount) => pageCount || 0
);

export default {
  getCollectionsData,
  getCurrencyData,
  getGroupLabel,
  getHasLoaded,
  getPageCount,
};
